export default class AbortError extends Error {
  constructor() {
    super('リクエストが中断されました')
    this.name = 'AbortError'
  }
}
